"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5761],{

/***/ 31751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var use_media__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81145);
/* harmony import */ var _products_YDSProductCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56142);
/* harmony import */ var constants_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67546);






var CMS_CardProduct_Comp = function(param) {
    var content = param.content;
    var isMobile = (0,use_media__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
        maxWidth: constants_constants__WEBPACK_IMPORTED_MODULE_4__/* .BREAKPOINT */ .Bs
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_products_YDSProductCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        product: content.product,
        row: isMobile,
        showReviews: true
    });
};
CMS_CardProduct_Comp.defaultProps = {
    content: {}
};
CMS_CardProduct_Comp.propTypes = {
    content: prop_types__WEBPACK_IMPORTED_MODULE_5__.object.isRequired
};
var CMS_CardProduct = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_1__.memo(CMS_CardProduct_Comp);
/* harmony default export */ __webpack_exports__["default"] = (CMS_CardProduct);


/***/ }),

/***/ 56142:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ products_YDSProductCard; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(98788);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var router = __webpack_require__(5632);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ../../packages/commerce/src/hooks/tracking/useTracker.ts
var useTracker = __webpack_require__(69590);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/BadgeGroup/index.js + 1 modules
var BadgeGroup = __webpack_require__(40286);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/molecules/ProductCard/ProductCardSkeleton.jsx
var ProductCardSkeleton = __webpack_require__(23772);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/ProductCardImage/index.js + 1 modules
var ProductCardImage = __webpack_require__(11962);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/ProductCardBody/index.js + 1 modules
var ProductCardBody = __webpack_require__(69654);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/molecules/ProductCardAction/index.js + 1 modules
var ProductCardAction = __webpack_require__(61687);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/ProductCardCaption/index.js + 1 modules
var ProductCardCaption = __webpack_require__(23341);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/ProductCardStockInformation/ProductCardStockInformation.jsx



var ProductCardStockInformation = function(param) {
    var stock = param.stock, stockUnit = param.stockUnit, className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classnames_default()(className, "bg-brand-tertiary-300"),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
            className: "m-0 flex justify-between px-3 py-1",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    className: "font-body-regular text-ui-gray-500 ",
                    children: "Stock"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "font-body-bold text-ui-gray-900",
                    children: [
                        stock,
                        stockUnit && stockUnit.length ? stockUnit : "pz"
                    ]
                })
            ]
        })
    });
};
ProductCardStockInformation.propTypes = {
    className: (prop_types_default()).string,
    stock: (prop_types_default()).number,
    stockUnit: (prop_types_default()).string
};
/* harmony default export */ var ProductCardStockInformation_ProductCardStockInformation = (ProductCardStockInformation);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/ProductCardStockInformation/index.js


;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/ProductCard/ProductCard.jsx











var ProductCard = function(param) {
    var className = param.className, redirectToProductPage = param.redirectToProductPage, CTAComponent = param.CTAComponent, _isError = param.isError, isError = _isError === void 0 ? false : _isError, _loading = param.loading, loading = _loading === void 0 ? true : _loading, showRatings = param.showRatings, product = param.product, style = param.style, context = param.context, cardType = param.cardType, onClickOnCard = param.onClickOnCard;
    var firstApplicableRule = product.firstApplicableRule, stock = product.stock, availableStockUnit = product.availableStockUnit;
    var isPOS = context === "pos";
    var rootClass = classnames_default()("h-full mx-auto pb-2 relative bg-ui-white shadow-down lg:shadow-none lg:hover:shadow-down duration-300 ease-out content-start grid grid-cols-two-sm xxs:grid-cols-two-lg lg:grid-cols-1", className, {
        "shadow-sm hover:shadow-lg": isPOS
    });
    if (loading || isError) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardSkeleton/* default */.Z, {
        isError: isError
    });
    if (!product || !product.name) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: rootClass,
            style: style,
            children: [
                isPOS && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardStockInformation_ProductCardStockInformation, {
                    className: "col-start-1 col-end-3 w-full",
                    stock: stock,
                    stockUnit: availableStockUnit
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ProductCardAction/* default */.Z, {
                    className: "col-start-1 col-end-3 grid items-end gap-x-2 lg:col-end-2 lg:grid-cols-1",
                    product: product,
                    redirectToProductPage: redirectToProductPage,
                    onClickOnCard: onClickOnCard,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardImage/* default */.Z, {
                            product: product,
                            fadeIfUnavailable: true,
                            cardType: cardType,
                            className: "mb-1 pb-[90px] xxs:pb-[108px] lg:mt-0 lg:mb-0 lg:pb-[246px]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeGroup/* default */.Z, {
                            product: product,
                            className: "mt-2",
                            cardType: cardType
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardBody/* default */.Z, {
                            product: product,
                            showRatings: showRatings,
                            cardType: cardType,
                            className: classnames_default()("col-start-2 col-end-4 h-full justify-between pt-2 pr-3 md:justify-between lg:col-start-1 lg:col-end-1 lg:px-4", {
                                "pb-0": isPOS && firstApplicableRule
                            })
                        }),
                        isPOS && firstApplicableRule && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-start-2 pl-0 pr-3 lg:col-start-1 lg:-mt-2 lg:pr-4 lg:pl-4 lg:pb-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCardCaption["default"], {
                                promotion: firstApplicableRule
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "col-start-1 col-end-3 px-2 pt-2 xxs:col-start-2 lg:col-end-1 lg:px-4",
                    children: CTAComponent
                })
            ]
        })
    });
};
ProductCard.displayName = "ProductCard";
ProductCard.defaultProps = {
    showRatings: true,
    redirectToProductPage: true,
    isPOS: false,
    cardType: "catalog"
};
ProductCard.propTypes = {
    className: prop_types.string,
    redirectToProductPage: prop_types.bool,
    showRatings: prop_types.bool,
    loading: prop_types.bool,
    isError: prop_types.bool,
    CTAComponent: prop_types.object,
    product: prop_types.object,
    cardType: prop_types.string,
    context: prop_types.oneOf([
        "sf",
        "pos"
    ]),
    onClickOnCard: prop_types.func
};
/* harmony default export */ var ProductCard_ProductCard = (/*#__PURE__*/react.memo(ProductCard));

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/molecules/ProductCard/index.js


;// CONCATENATED MODULE: ./components/products/YDSProductCard.js









var AddToCart = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 1319).then(__webpack_require__.bind(__webpack_require__, 11319));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11319)
            ];
        }
    },
    ssr: false
});
var YDSProductCard_Comp = function(param) {
    var className = param.className, error = param.error, loading = param.loading, product = param.product, handleBeforeClickOnProduct = param.handleBeforeClickOnProduct;
    var trackEvent = (0,useTracker/* default */.Z)().trackEvent;
    if (!product || !product.name) return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    var handleClickOnCard = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee(e) {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(typeof handleBeforeClickOnProduct === "function")) {
                            _ctx.next = 3;
                            break;
                        }
                        _ctx.next = 3;
                        return handleBeforeClickOnProduct(e, product);
                    case 3:
                        if (e && !e.ctrlKey && !e.metaKey) {
                            router_default().push(product.href);
                        }
                        trackEvent({
                            type: "Product Clicked",
                            data: {
                                rawProduct: product
                            }
                        });
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleClickOnCard(e) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductCard_ProductCard, {
        className: className,
        CTAComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCart, {
            product: product,
            cardType: "catalog"
        }),
        isError: !!error,
        loading: loading,
        product: product,
        cardType: "catalog",
        context: "sf",
        withDropdownPill: product.sellingType === "por-pieza-peso",
        onClickOnCard: handleClickOnCard
    });
};
YDSProductCard_Comp.defaultProps = {
    error: false,
    loading: false
};
YDSProductCard_Comp.propTypes = {
    children: prop_types.node,
    className: prop_types.string,
    error: prop_types.oneOfType([
        prop_types.bool,
        prop_types.object
    ]),
    loading: prop_types.bool,
    product: prop_types.object,
    handleBeforeClickOnProduct: prop_types.func
};
var YDSProductCard = /*#__PURE__*/ react.memo(YDSProductCard_Comp);
/* harmony default export */ var products_YDSProductCard = (YDSProductCard);


/***/ }),

/***/ 68113:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Badge_Badge; }
});

// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(47842);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(96670);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../packages/designkit/src/components/webkit/atoms/Link/index.js
var Link = __webpack_require__(35384);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Badge/Badge.jsx








var Badge = function(param) {
    var className = param.className, bgColor = param.bgColor, textColor = param.textColor, type = param.type, children = param.children, href = param.href, style = param.style;
    var _obj;
    var rootClass = classnames_default()(className, "inline-block font-body", (_obj = {
        "shadow-down text-small rounded-l-none rounded-r-sm px-2 py-1": type === "generic" || type === "initial" || type === "stockout",
        "text-small rounded-xxl px-2 py-1": type === "round",
        "shadow-down text-caption leading-tight border-solid border border-brand-primary-700 rounded-sm px-1 py-0": type === "discount",
        "shadow-down font-body font-body-normal text-small underline rounded-bl-md px-2 py-1 cursor-pointer": type === "linkTop",
        "shadow-down font-body font-body-normal text-small underline rounded-tl-md px-2 py-1 cursor-pointer": type === "linkBottom",
        "bg-brand-secondary-700": !bgColor && type === "generic",
        "bg-ui-success": !bgColor && type === "round",
        "bg-brand-tertiary-500": !bgColor && type === "initial",
        "bg-ui-gray-300": !bgColor && type === "stockout",
        "bg-ui-white": !bgColor && type === "discount"
    }, (0,_define_property/* default */.Z)(_obj, bgColor, bgColor), (0,_define_property/* default */.Z)(_obj, "text-ui-white", !textColor && (type === "generic" || type === "initial" || type === "round")), (0,_define_property/* default */.Z)(_obj, "text-ui-gray-900", !textColor && type === "stockout"), (0,_define_property/* default */.Z)(_obj, "text-brand-primary-700", !textColor && type === "discount"), (0,_define_property/* default */.Z)(_obj, "text-ui-black", !textColor && (type === "linkTop" || type === "linkBottom")), (0,_define_property/* default */.Z)(_obj, "font-body-normal ".concat(textColor), textColor), _obj));
    var colorRGB = "#FDF2F1";
    var colorRGBA = colorRGB + "80";
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
        className: rootClass,
        style: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, style), {
            backgroundColor: type === "linkBottom" || type === "linkTop" ? colorRGBA : ""
        }),
        children: type === "linkBottom" || type === "linkTop" ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link["default"], {
            href: href,
            children: children
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: children
        })
    });
};
Badge.defaultProps = {
    type: "generic"
};
Badge.propTypes = {
    className: prop_types.string,
    textColor: prop_types.string,
    bgColor: prop_types.string,
    /** Badge variants: intial, stock-out, generic, discount, etc. */ type: prop_types.oneOf([
        "generic",
        "round",
        "initial",
        "stockout",
        "discount",
        "linkTop",
        "linkBottom", 
    ]),
    children: prop_types.string.isRequired,
    href: prop_types.string
};
/* harmony default export */ var Badge_Badge = (Badge);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Badge/index.js



/***/ }),

/***/ 29832:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ProductPriceForQuantity; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var sf_modules__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37555);
/* harmony import */ var _Badge__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(68113);





ProductPriceForQuantity.propTypes = {
    wrapperClassName: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    pricesWrapperClassName: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    discountsWrapperClassName: prop_types__WEBPACK_IMPORTED_MODULE_4__.string,
    context: prop_types__WEBPACK_IMPORTED_MODULE_4__.oneOf([
        "pos",
        "cart",
        "checkout",
        "success",
        "profileOrder",
        "hit",
        "product-page",
        "modal",
        "default", 
    ]),
    product: prop_types__WEBPACK_IMPORTED_MODULE_4__.object,
    hideDiscounts: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool
};
ProductPriceForQuantity.defaultProps = {
    context: "default",
    hideDiscounts: false
};
function ProductPriceForQuantity(param) {
    var wrapperClassName = param.wrapperClassName, pricesWrapperClassName = param.pricesWrapperClassName, discountsWrapperClassName = param.discountsWrapperClassName, hideDiscounts = param.hideDiscounts, context = param.context, product = param.product;
    if (!(product === null || product === void 0 ? void 0 : product.catalogPrice)) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
    if (product.isGift) {
        var nbGifts = product.productsGifted || 1;
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
            className: "font-semibold font-body text-normal leading-tight text-ui-gray-900",
            children: [
                "Regalo",
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                    className: "ml-1 text-small font-body-regular text-ui-gray-500",
                    children: [
                        "(",
                        nbGifts,
                        " unidad",
                        nbGifts > 1 && "es",
                        ")"
                    ]
                })
            ]
        });
    }
    var regularPricePerUnit;
    var priceToPayPerUnit;
    var totalPriceToPay;
    var pricePerQuantityUnit;
    var sellingValue = Number(product.sellingValue);
    var refinedSellingValue = Number.isInteger(sellingValue) ? sellingValue : sellingValue.toFixed(1);
    var productQuantityForPrice = product.sellingUnit && "(".concat(refinedSellingValue, " ").concat(product.sellingUnit, ")");
    var isBuyingContext = false;
    switch(context){
        case "pos":
        case "cart":
        case "checkout":
            isBuyingContext = true;
            totalPriceToPay = product.totalPrice;
            priceToPayPerUnit = totalPriceToPay / product.billedQuantity;
            regularPricePerUnit = priceToPayPerUnit < product.catalogPrice.price ? product.catalogPrice.price : null;
            break;
        case "success":
        case "profileOrder":
            isBuyingContext = true;
            totalPriceToPay = product.paidPricing.totalPrice;
            priceToPayPerUnit = totalPriceToPay / product.billedQuantity;
            regularPricePerUnit = priceToPayPerUnit < product.paidPricing.priceUndiscounted ? product.paidPricing.priceUndiscounted : null;
            break;
        case "product-page":
            totalPriceToPay = null;
            priceToPayPerUnit = product.catalogPrice.discountedPrice;
            regularPricePerUnit = priceToPayPerUnit < product.catalogPrice.price ? product.catalogPrice.price : null;
            pricePerQuantityUnit = refinedSellingValue && "".concat(sf_modules__WEBPACK_IMPORTED_MODULE_2__/* .money.formatMoney */ .CZ.formatMoney(product.catalogPrice.discountedPrice / refinedSellingValue), " / ").concat(product.sellingUnit);
            break;
        default:
            totalPriceToPay = null;
            priceToPayPerUnit = product.catalogPrice.discountedPrice;
            regularPricePerUnit = priceToPayPerUnit < product.catalogPrice.price ? product.catalogPrice.price : null;
            productQuantityForPrice = product.sellingUnit && refinedSellingValue + " " + product.sellingUnit;
            break;
    }
    var saleByWeight = product.sellingType && product.sellingType !== "por-pieza";
    var showProductQuantityForPrice = !saleByWeight || context === "default";
    var discount = sf_modules__WEBPACK_IMPORTED_MODULE_2__/* .money.getDiscount */ .CZ.getDiscount(priceToPayPerUnit, regularPricePerUnit);
    var sellingPresentation = saleByWeight && refinedSellingValue ? " / ".concat(refinedSellingValue > 1 ? "".concat(refinedSellingValue, " ") : "").concat(product.sellingUnit) : product.isBundle ? " / pack" : " / pz";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(wrapperClassName, {
            "mt-1 flex w-full flex-col-reverse md:flex-row md:items-end md:justify-between": showProductQuantityForPrice
        }),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(pricesWrapperClassName, "mr-2 flex justify-start"),
                children: [
                    !hideDiscounts && regularPricePerUnit && discount ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()(discountsWrapperClassName, "flex items-center"),
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("mr-1", "font-body leading-tight line-through", "text-caption text-ui-gray-500"),
                                children: sf_modules__WEBPACK_IMPORTED_MODULE_2__/* .money.formatMoney */ .CZ.formatMoney(regularPricePerUnit)
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Badge__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                type: "discount",
                                children: discount
                            })
                        ]
                    }) : context !== "pos" && !hideDiscounts ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "h-4"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {}),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex flex-wrap items-center font-body text-normal",
                        children: [
                            !hideDiscounts && isBuyingContext && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "flex-shrink-0 text-sm font-body-bold text-ui-gray-900",
                                        children: sf_modules__WEBPACK_IMPORTED_MODULE_2__/* .money.formatMoney */ .CZ.formatMoney(totalPriceToPay)
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "mx-2 inline-block h-1 w-1 flex-shrink-0 rounded-full bg-brand-secondary-700"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex-shrink-0", isBuyingContext ? "leading-tight text-ui-gray-500" : "font-body-bold text-ui-gray-900", context === "hit" ? "text-caption" : "text-normal"),
                                children: [
                                    sf_modules__WEBPACK_IMPORTED_MODULE_2__/* .money.formatMoney */ .CZ.formatMoney(priceToPayPerUnit),
                                    context !== "default" && sellingPresentation
                                ]
                            })
                        ]
                    })
                ]
            }),
            showProductQuantityForPrice && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: classnames__WEBPACK_IMPORTED_MODULE_1___default()("flex-shrink-0 font-body leading-tight md:flex md:items-end", "text-left text-ui-gray-900 md:text-right", context === "product-page" ? "text-normal font-body-regular lg:flex-col" : "text-small font-body-regular"),
                children: [
                    pricePerQuantityUnit && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "hidden text-caption font-body-regular text-ui-gray-500 lg:block",
                        children: pricePerQuantityUnit
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "text-caption text-black",
                        children: productQuantityForPrice
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 50952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Rating_Rating; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/prop-types/index.js
var prop_types = __webpack_require__(13980);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../packages/sf-modules/src/index.js + 26 modules
var src = __webpack_require__(37555);
// EXTERNAL MODULE: ../../packages/icons/solid/esm/StarIcon.js
var StarIcon = __webpack_require__(57764);
;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Rating/Stars.js






function between(x, min, max) {
    return x >= min && x <= max;
}
function setRating(rating) {
    var decimals = rating - Math.floor(rating);
    var newRating = +decimals.toFixed(1);
    var integer = src/* polyfills.truncate */.dF.truncate(rating);
    if (between(newRating, 0.1, 0.3)) rating = integer + 0.4;
    else if (between(newRating, 0.31, 0.5)) rating = integer + 0.5;
    return rating / 0.05;
}
// Hover and click allowed.
var StarsHovered = function(param) {
    var sizes = param.sizes, rating = param.rating, hovered = param.hovered, onChange = param.onChange;
    var handleChange = function handleChange(value) {
        if (hovered) {
            setClickScore(value);
            onChange(value);
        }
    };
    var handleHover = function handleHover(value) {
        if (hovered) {
            setHoverScore(value);
        }
    };
    var ref = (0,react.useState)(rating), clickScore = ref[0], setClickScore = ref[1];
    var ref1 = (0,react.useState)(rating), hoverScore = ref1[0], setHoverScore = ref1[1];
    return [
        1,
        2,
        3,
        4,
        5
    ].map(function(ratingValue) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "px-1",
            onClick: function() {
                return handleChange(ratingValue);
            },
            onMouseOver: function() {
                return handleHover(ratingValue);
            },
            onMouseOut: function() {
                return handleHover(0);
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarIcon/* default */.Z, {
                className: classnames_default()(sizes.iconSize, ratingValue <= (hoverScore || clickScore) ? "text-ui-warning" : "text-ui-gray-300")
            })
        }, ratingValue);
    });
};
var Stars = function(param) {
    var size = param.size, rating = param.rating, hovered = param.hovered, onChange = param.onChange;
    var sizes = {
        iconSize: size === "lg" ? "w-10 h-10" : size === "md" ? "w-6 h-6" : "w-4 h-4",
        totalWidth: size === "lg" ? "w-[15rem]" : size === "md" ? "w-[10rem]" : "w-[7.5rem]"
    };
    var ratingWidth = setRating(rating);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "relative -ml-1",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex leading-none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarsHovered, {
                    sizes: sizes,
                    rating: rating,
                    hovered: hovered,
                    onChange: onChange
                })
            }),
            !hovered && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "absolute top-0 left-0 h-full overflow-hidden",
                style: {
                    width: ratingWidth + "%"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()(sizes.totalWidth, "text-left leading-none"),
                    children: [
                        1,
                        2,
                        3,
                        4,
                        5
                    ].map(function(ratingValue) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: "px-1",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StarIcon/* default */.Z, {
                                className: classnames_default()(sizes.iconSize, "text-ui-warning")
                            })
                        }, ratingValue);
                    })
                })
            })
        ]
    });
};
Stars.propTypes = {
    size: prop_types.oneOf([
        "sm",
        "md",
        "lg"
    ]),
    rating: prop_types.number,
    hovered: prop_types.bool,
    onChange: prop_types.func
};
Stars.defaultProps = {
    hovered: false,
    size: "sm"
};
/* harmony default export */ var Rating_Stars = (/*#__PURE__*/react.memo(Stars));

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Rating/Rating.jsx





var Rating = function(param) {
    var className = param.className, size = param.size, review = param.review, rating = param.rating, hovered = param.hovered, onChange = param.onChange;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()("flex w-auto flex-wrap items-center", className),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Rating_Stars, {
                    onChange: onChange,
                    hovered: hovered,
                    size: size,
                    rating: rating
                }),
                review != null && !hovered && /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                    className: "font-regular ml-1 font-body text-caption font-body-regular text-ui-gray-900",
                    style: {
                        marginTop: "2px"
                    },
                    children: [
                        "(",
                        review,
                        ")"
                    ]
                })
            ]
        })
    });
};
Rating.propTypes = {
    className: prop_types.string,
    size: prop_types.oneOf([
        "sm",
        "md",
        "lg"
    ]),
    review: prop_types.number,
    rating: prop_types.number,
    hovered: prop_types.bool
};
Rating.defaultProps = {
    size: "sm"
};
/* harmony default export */ var Rating_Rating = (Rating);

;// CONCATENATED MODULE: ../../packages/designkit/src/components/webkit/atoms/Rating/index.js



/***/ }),

/***/ 23772:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(13980);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51992);
/* harmony import */ var use_media__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81145);





var ProductCardSkeleton = function(param) {
    var _isError = param.isError, isError = _isError === void 0 ? false : _isError;
    var isMobile = (0,use_media__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)({
        maxWidth: 640
    });
    var errorMsg = "Error de carga";
    var duration = isError ? 0 : 1.2;
    if (isMobile) return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex w-full",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                            duration: duration,
                            width: 108,
                            height: 108
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-full pl-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                duration: duration,
                                width: 62,
                                height: 12
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "mb-0 -mt-1",
                                children: isError ? errorMsg : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                    duration: duration
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                duration: duration,
                                width: 102
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "mt-4 flex w-full justify-between",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                        duration: duration,
                                        width: 100,
                                        height: 20
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                        duration: duration,
                                        width: 30,
                                        height: 20
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                style: {
                    marginLeft: "116px"
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    className: "mt-3",
                    style: {
                        borderRadius: "24px"
                    },
                    duration: duration,
                    height: 40
                })
            })
        ]
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "mx-auto w-full",
        style: {
            maxWidth: "246px"
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "-mt-1",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                    duration: duration,
                    height: 246
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "px-4 pt-1 pb-4",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                        duration: duration,
                        width: 62,
                        height: 12
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "mb-1 -mt-1",
                        children: isError ? errorMsg : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                            duration: duration,
                            width: 214,
                            height: 34
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                        duration: duration,
                        width: 160
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                        duration: duration,
                        width: 120
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "mb-0"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-between",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                duration: duration,
                                width: 100,
                                height: 16
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                                duration: duration,
                                width: 30,
                                height: 16
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_loading_skeleton__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                        className: "mt-1",
                        style: {
                            borderRadius: "24px"
                        },
                        duration: duration,
                        height: 40
                    })
                ]
            })
        ]
    });
};
ProductCardSkeleton.propTypes = {
    isError: prop_types__WEBPACK_IMPORTED_MODULE_4__.bool
};
/* harmony default export */ __webpack_exports__["Z"] = (ProductCardSkeleton);


/***/ }),

/***/ 14718:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function CheckIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M8.25 21a.375.375 0 01-.265-.11L3.11 16.015a.375.375 0 01.53-.53l4.563 4.562L20.32 3.156a.378.378 0 01.523-.086.372.372 0 01.152.244.372.372 0 01-.065.28L8.554 20.844A.376.376 0 018.28 21h-.03z"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(CheckIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ }),

/***/ 57764:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);

function StarIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    d: "M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z",
    clipRule: "evenodd"
  }));
}
const ForwardRef = react__WEBPACK_IMPORTED_MODULE_0__.forwardRef(StarIcon);
/* harmony default export */ __webpack_exports__["Z"] = (ForwardRef);

/***/ })

}]);